import { CheckboxVisibility, ColumnActionsMode, ColumnDragEndLocation, ConstrainMode, DetailsListLayoutMode } from "@fluentui/react/lib/DetailsList";
var DetailsListTypes = /* @__PURE__ */ ((DetailsListTypes2) => {
  DetailsListTypes2["default"] = "default";
  DetailsListTypes2["alternate"] = "alternate";
  return DetailsListTypes2;
})(DetailsListTypes || {});
var DetailsListDataTypes = /* @__PURE__ */ ((DetailsListDataTypes2) => {
  DetailsListDataTypes2[DetailsListDataTypes2["string"] = 0] = "string";
  DetailsListDataTypes2[DetailsListDataTypes2["number"] = 1] = "number";
  DetailsListDataTypes2[DetailsListDataTypes2["boolean"] = 2] = "boolean";
  DetailsListDataTypes2[DetailsListDataTypes2["date"] = 3] = "date";
  DetailsListDataTypes2[DetailsListDataTypes2["object"] = 4] = "object";
  return DetailsListDataTypes2;
})(DetailsListDataTypes || {});
export {
  CheckboxVisibility,
  ColumnActionsMode,
  ColumnDragEndLocation,
  ConstrainMode,
  DetailsListDataTypes,
  DetailsListLayoutMode,
  DetailsListTypes
};
//# sourceMappingURL=DetailsList.types.js.map
